import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { Helpers } from "src/helpers/helpers";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { CareplusFee } from "src/dto/request/careplus-fee";

@Injectable({
  providedIn: "root",
})
export class CareplusFeeService extends BaseService {
  constructor(private http: HttpClient, helper: Helpers) {
    super(helper);
  }

  getFees(): Observable<CareplusFee> {
    return this.http
      .get<CareplusFee>(environment.apiUrl + "Careplus/Fee", super.header())
      .pipe(catchError(super.handleError));
  }

  updateFees(body: CareplusFee): Observable<void> {
    return this.http
      .post<void>(environment.apiUrl + "Careplus/Fee", body, super.header())
      .pipe(catchError(super.handleError));
  }
}
